import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { concat, EMPTY, of } from 'rxjs';
import axios from 'axios-observable';
import { PayloadEpic } from '@/store/epics/epic-types';
import { actions, asyncActions } from '@/store/slices';
import { apiEndpoints } from '@/store/constants';
import { EntityId } from '@reduxjs/toolkit';
import { FetchRouteStopByIdPayload } from '@/store/slices/staff/route-stops.slice';
import { RouteStopModel } from '@/models';

export const fetchRouteStopByIdEpic: PayloadEpic<FetchRouteStopByIdPayload, RouteStopModel> = (action$) => {
    return action$.pipe(
        filter(asyncActions.routeStops.fetchById.match),
        switchMap(({ payload }) =>
            concat(
                of(actions.routeStops.setIsLoading(true)),
                fetchRouteStopById(payload.routeStopId).pipe(
                    map(({ data }) => actions.routeStops.upsertOne(data)),
                    catchError((error) => {
                        console.error('fetchRouteStopByIdEpic', error);
                        return EMPTY;
                    })
                ),
                of(actions.routeStops.setIsLoading(false))
            )
        )
    );
};

const fetchRouteStopById = (routeStopId: EntityId) => {
    return axios.get<RouteStopModel>(apiEndpoints.routeStop(routeStopId));
};
